import React from "react";
import { Link } from "react-router-dom";
import { ASSETS } from "@/data/site";

// variant: "dark" => light text (for navy backgrounds), "light" => navy text (for white backgrounds)
export const Logo = ({ variant = "dark", className = "", showText = true, testId = "site-logo" }) => {
  const isDark = variant === "dark";
  const titleColor = isDark ? "#FFFFFF" : "var(--ssa-navy)";
  const subColor = isDark ? "rgba(255,255,255,0.65)" : "var(--ssa-turquoise)";

  return (
    <Link to="/" data-testid={testId} className={`flex items-center gap-3 ${className}`} aria-label="Speed Shipping Agencies — Home">
      <img
        src={ASSETS.emblem}
        alt="Speed Shipping Agencies emblem"
        className="h-10 w-10 sm:h-11 sm:w-11 object-contain shrink-0"
        draggable="false"
      />
      {showText && (
        <span className="flex flex-col leading-none">
          <span
            className="font-display font-semibold text-[15px] sm:text-[17px] tracking-[0.02em]"
            style={{ color: titleColor }}
          >
            SPEED SHIPPING
          </span>
          <span
            className="eyebrow mt-1 text-[9px] sm:text-[10px]"
            style={{ color: subColor, letterSpacing: "0.42em" }}
          >
            AGENCIES
          </span>
        </span>
      )}
    </Link>
  );
};
